<template>

  <ReportViewSpecific :busy="busy" title="checklist-evidence">

    <!-- LOADING OVERLAY -->
    <div
        class="h-100-header d-flex justify-content-center align-items-center"
        v-if="imagesLoading"
    >
      <div class="progress-wrapper text-center">

        <div class="progress-text mb-3">
          Carregando imagens
        </div>

        <b-progress
            :value="imagesLoaded"
            :max="imagesTotal"
            height="38px"
            animated
            striped
            variant="primary"
            class="mb-2"
        >
          <b-progress-bar
              :value="imagesLoaded"
              :max="imagesTotal"
          >
            {{ imagesLoaded }} / {{ imagesTotal }}
          </b-progress-bar>
        </b-progress>

        <div class="text-muted small">
          {{ progressPercent }}%
        </div>

      </div>
    </div>


    <div v-show="!imagesLoading"
         v-for="checklistEnvironment in checklistEnvironmentList.filter(a => a.qtyEvidenceFile > 0)"
         data-report-block="1"
         :key="checklistEnvironment.checklistEnvironmentId">

      <div style="font-weight:bold; font-size:14pt; margin-bottom:15px; font-family:Arial"
           data-report-title="1"
           v-if="!reportHideEnvironment">
        {{ checklistEnvironment.environment }}
      </div>


      <div
          v-for="(pagePhotos, pageIdx) in getEnvironmentPhotoPages(checklistEnvironment.checklistEnvironmentId)"
          :key="'page-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx"
          data-break-container="1"
          style="page-break-after: always; mso-page-break-after: always; margin-top:20px">


        <table
            v-if="designType === ReportEvidenceDesignType.type.DEFAULT"
            align="center"
            border="0"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.DEFAULT"
            style="border-collapse:collapse; width:100%; table-layout:fixed;"
        >
          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                align="center"
                valign="top"
                style="padding:8px; width:50%;"
                data-table-cell-padding-top="20px"
                data-table-cell-padding-bottom="70px"
            >
              <img
                  :src="photo.fileWebMedium"
                  :width="evidenceLayoutType.imageWidth"
                  :height="evidenceLayoutType.imageHeight"
                  @load="onImgDone()"
                  @error="onImgDone(true, photo)"
                  style="display:block; border:0; margin:0 auto;"
              >
              <div
                  align="center"
                  style="font-size:9pt; padding-top:4pt; font-family:Arial; margin-bottom: 100px;"
                  data-report-caption="1"
                  v-html="subtitleTextComplete(checklistEnvironment, photo, false)"
              >
              </div>
            </td>

            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="padding:8px; width:50%;"
            >
              &nbsp;
            </td>
          </tr>
        </table>

        <table
            v-else-if="designType === ReportEvidenceDesignType.type.TEXT_OVERLAY_TOP"
            align="center"
            border="0"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.TEXT_OVERLAY_TOP"
            style="border-collapse:collapse; width:100%; table-layout:fixed; font-family:Arial; font-size:10pt;"
        >
          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-text-overlay-top-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                valign="top"
                style="width:50%; padding:8px; border:0;"
                data-report-photo-card="1"
            >

              <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse:collapse; width:100%; table-layout:fixed;"
              >
                <tr>

                  <td
                      align="center"
                      valign="middle"
                      style="padding:4px 6px 6px 6px; font-size:10pt;"
                      data-report-photo-header="1"
                  >

                    <span v-if="subtitleFormat === ReportSubtitleType.type.BASIC">
                      {{ textCheckUpperCase(sequenceOtherLabel) }} {{ photo.position }} -
                      {{ textCheckUpperCase(photo.subtitle) }}
                    </span>

                    <span v-else-if="subtitleFormat === ReportSubtitleType.type.NOT_ENVIRONMENT">
                      {{ textCheckUpperCase(sequenceOtherLabel) }} {{ photo.position }}
                      <span v-if="photo.environmentComplement && photo.environmentComplement.length > 0"> - {{
                          textCheckUpperCase(photo.environmentComplement)
                        }}: </span>
                      <span v-else> -</span>
                      {{ textCheckUpperCase(photo.subtitle) }}

                    </span>

                    <span v-else-if="subtitleFormat === ReportSubtitleType.type.FULL">
                      {{ textCheckUpperCase(sequenceOtherLabel) }} {{ photo.position }} -
                      {{ textCheckUpperCase(checklistEnvironment.environment) }}

                      <span v-if="photo.environmentComplement && photo.environmentComplement.length > 0">
                      - {{ textCheckUpperCase(photo.environmentComplement) }}
                    </span>
                      -
                      {{ textCheckUpperCase(photo.subtitle) }}
                    </span>


                  </td>
                </tr>

                <tr>
                  <td
                      align="center"
                      valign="middle"
                      style="padding:0 4px 8px 4px; height:300px;"
                      data-report-photo-image="1"
                      data-table-cell-padding-top="0px"
                      data-table-cell-padding-bottom="8px"
                  >
                    <img
                        :src="photo.fileWebMedium"
                        :width="evidenceLayoutType.imageWidth || 280"
                        :height="evidenceLayoutType.imageHeight || 360"
                        @load="onImgDone()"
                        @error="onImgDone(true, photo)"
                        style="display:block; object-fit:contain; max-width:100%;"
                    >
                  </td>
                </tr>
              </table>

            </td>

            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="padding:8px; width:50%; border:0;"
                data-report-photo-card="empty"
            >
              &nbsp;
            </td>
          </tr>
        </table>


        <table
            v-else-if="designType === ReportEvidenceDesignType.type.TEXT_OVERLAY_TOP"
            align="center"
            border="0"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.TEXT_OVERLAY_TOP"
            style="border-collapse:collapse; width:100%; table-layout:fixed; font-family:Arial; font-size:9pt;"
        >
          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-text-overlay-top-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                valign="top"
                style="width:50%; padding:8px; border:0;"
                data-report-photo-card="1"
            >

              <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse:collapse; width:100%; table-layout:fixed;"
              >
                <tr>

                  <td
                      align="center"
                      valign="middle"
                      style="padding:4px 6px 6px 6px; font-size:10pt;"
                      data-report-photo-header="1"
                  >

                    <span v-if="subtitleFormat === ReportSubtitleType.type.BASIC">
                      {{ textCheckUpperCase(sequenceOtherLabel) }} {{ photo.position }} -
                      {{ textCheckUpperCase(photo.subtitle) }}
                    </span>

                    <span v-else-if="subtitleFormat === ReportSubtitleType.type.NOT_ENVIRONMENT">
                      {{ textCheckUpperCase(sequenceOtherLabel) }} {{ photo.position }}
                      <span v-if="photo.environmentComplement && photo.environmentComplement.length > 0"> - {{
                          textCheckUpperCase(checklistEnvironment.environmentComplement)
                        }}</span> -
                      {{ textCheckUpperCase(photo.subtitle) }}

                    </span>

                    <span v-else-if="subtitleFormat === ReportSubtitleType.type.FULL">
                      {{ textCheckUpperCase(sequenceOtherLabel) }} {{ photo.position }} -
                      {{ textCheckUpperCase(checklistEnvironment.environment) }}

                      <span v-if="photo.environmentComplement && photo.environmentComplement.length > 0">
                      - {{ textCheckUpperCase(photo.environmentComplement) }}
                    </span>
                      -
                      {{ textCheckUpperCase(photo.subtitle) }}
                    </span>


                  </td>
                </tr>

                <tr>
                  <td
                      align="center"
                      valign="middle"
                      style="padding:0 4px 8px 4px; height:300px;"
                      data-report-photo-image="1"
                      data-table-cell-padding-top="0px"
                      data-table-cell-padding-bottom="8px"
                  >
                    <img
                        :src="photo.fileWebMedium"
                        :width="evidenceLayoutType.imageWidth || 280"
                        :height="evidenceLayoutType.imageHeight || 360"
                        @load="onImgDone()"
                        @error="onImgDone(true, photo)"
                        style="display:block; object-fit:contain; max-width:100%;"
                    >
                  </td>
                </tr>
              </table>

            </td>

            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="padding:8px; width:50%; border:0;"
                data-report-photo-card="empty"
            >
              &nbsp;
            </td>
          </tr>
        </table>


        <table
            v-else-if="designType === ReportEvidenceDesignType.type.LIGHT_BORDER_BOTTOM_TEXT"
            align="center"
            border="0"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.LIGHT_BORDER_BOTTOM_TEXT"
            style="border-collapse:collapse; width:100%; table-layout:fixed; font-family:Arial; font-size:9pt;"
        >
          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-light-border-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                valign="top"
                style="width:50%; padding:0px;"
                data-report-photo-card="1"
                data-report-light-border="1"
            >

              <table
                  width="100%"
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse:collapse; width:100%; table-layout:fixed; border:1px solid #bdbdbd;"
              >

                <tr>
                  <td
                      align="center"
                      valign="middle"
                      style="height:260px; border:0;"
                      data-report-photo-image="1"
                      data-table-cell-padding-top="4px"
                      data-table-cell-padding-bottom="4px"
                  >
                    <img
                        :src="photo.fileWebMedium"
                        :width="evidenceLayoutType.imageWidth || 260"
                        :height="evidenceLayoutType.imageHeight || 260"
                        @load="onImgDone()"
                        @error="onImgDone(true, photo)"
                        style="display:block; object-fit:contain; max-width:100%;"
                    >
                  </td>
                </tr>

                <tr>
                  <td
                      align="center"
                      valign="top"
                      style="padding:6px 8px; border-top:1px solid #bdbdbd; font-size:10pt; line-height:14px;"
                      data-report-photo-header="1"
                      v-html="subtitleTextComplete(checklistEnvironment, photo, true)"
                  >

                  </td>
                </tr>

              </table>

            </td>

            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="width:50%;"
                data-report-photo-card="empty"
            >
              &nbsp;
            </td>

          </tr>
        </table>


        <table
            v-else-if="designType === ReportEvidenceDesignType.type.HIGHLIGHT_PRESENTATION"
            align="center"
            border="1"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.HIGHLIGHT_PRESENTATION"
            style="border-collapse:collapse; width:100%; table-layout:fixed; font-family:Arial; font-size:9pt;"
        >


          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-tech-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                valign="top"
                style="width:50%; padding:0; border:2px solid #000;"
                data-report-photo-card="1"
                data-table-cell-border="1"
            >

              <!-- Cabeçalho da foto -->
              <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse:collapse; width:100%;"
              >
                <tr>
                  <td
                      align="right"
                      style="background:#e3e3e3; padding:4px 6px;"
                      data-report-photo-header="1"
                  >
                    <strong>{{ sequenceOtherLabel.toUpperCase() }} Nº {{ photo.position }}</strong>
                  </td>
                </tr>

                <tr>
                  <td
                      align="center"
                      valign="middle"
                      style="padding:18px 8px 22px 8px; height:330px;"
                      data-report-photo-image="1"
                      data-table-cell-padding-top="20px"
                      data-table-cell-padding-bottom="30px"
                  >
                    <img
                        :src="photo.fileWebMedium"
                        :width="evidenceLayoutType.imageWidth || 280"
                        :height="evidenceLayoutType.imageHeight || 360"
                        @load="onImgDone()"
                        @error="onImgDone(true, photo)"
                        style="display:block; object-fit:contain;"
                    >
                  </td>
                </tr>

                <tr v-if="objValid(photo.typeEvidenceStatus) && photo.typeEvidenceStatus !== ''">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1"
                  >
                    <strong>{{ (businessEvidenceFileRequiredFieldsObject.statusLabel || '').toUpperCase() }}: <span :style="{'color': photo.typeEvidenceStatusTextColor}">{{textCheckUpperCase(removeNumericPrefix(photo.typeEvidenceStatus))}}</span></strong>

                  </td>
                </tr>

                <tr v-if="reportHideEnvironment && subtitleFormat !== ReportSubtitleType.type.BASIC">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1"
                  >
                    <strong>{{(businessEvidenceFileRequiredFieldsObject.complementLabel || '').toUpperCase()}}:</strong>

                    <span v-if="subtitleFormat !== ReportSubtitleType.type.NOT_ENVIRONMENT"> {{ textCheckUpperCase(checklistEnvironment.environment) }}</span>

                    <span v-if="subtitleFormat === ReportSubtitleType.type.FULL && objValid(photo.environmentComplement) && photo.environmentComplement !== ''"> - {{ textCheckUpperCase(photo.environmentComplement) }}</span>

                    <span v-if="subtitleFormat === ReportSubtitleType.type.NOT_ENVIRONMENT"> {{textCheckUpperCase(photo.environmentComplement)}}</span>

                  </td>
                </tr>

                <tr v-if="objValid(photo.typeEvidenceServiceAutomatically) && photo.typeEvidenceServiceAutomatically !== ''">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1"
                  >
                    <strong>{{ (businessEvidenceFileRequiredFieldsObject.serviceLabel || '').toUpperCase() }}:</strong> {{ textCheckUpperCase(photo.typeEvidenceServiceAutomatically) }}</td>
                </tr>

                <tr v-if="objValid(photo.typeEvidenceCategory) && photo.typeEvidenceCategory !== ''">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1">
                    <strong>{{(businessEvidenceFileRequiredFieldsObject.categoryLabel || '').toUpperCase()}}: </strong>{{ textCheckUpperCase(removeNumericPrefix(photo.typeEvidenceCategory)) }}
                  </td>
                </tr>

                <tr v-if="photo.subtitle && photo.subtitle.length > 0">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-observation="1">
                    <strong>OBSERVAÇÃO: </strong>
                    <span>{{ photo.subtitle }}</span>

                  </td>
                </tr>
              </table>

            </td>

            <!-- Completa coluna vazia -->
            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="padding:8px; width:50%;"
            >
              &nbsp;
            </td>
          </tr>
        </table>


        <table
            v-else-if="designType === ReportEvidenceDesignType.type.TECHNICAL_HEADER_BORDER"
            align="center"
            border="1"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.TECHNICAL_HEADER_BORDER"
            style="border-collapse:collapse; width:100%; table-layout:fixed; font-family:Arial; font-size:9pt;"
        >
          <tr>
            <td colspan="2" align="center"
                style="padding:4px 6px;"
                data-report-full-title="1">
              <strong><span style="font-size: 20px;">{{ titleReport }}</span></strong><br/>
              <strong><span style="font-size: 14px;">{{ enterprise.title }}</span></strong><br/>
              <strong v-if="objValid(enterprise.startJob) && objValid(enterprise.finishJob)"><span
                  style="font-size: 14px;">{{ enterprise.startJob | date }} à {{
                  enterprise.finishJob | date
                }}</span></strong>
            </td>

          </tr>


          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-tech-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                valign="top"
                style="width:50%; padding:0; border:2px solid #000;"
                data-report-photo-card="1"
                data-table-cell-border="1"
            >

              <!-- Cabeçalho da foto -->
              <table
                  width="100%"
                  border="0"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse:collapse; width:100%;"
              >
                <tr>
                  <td
                      align="right"
                      style="background:#cfcfcf; padding:4px 6px;"
                      data-report-photo-header="1"
                  >
                    <strong>{{ sequenceOtherLabel.toUpperCase() }} Nº {{ photo.position }}</strong>
                  </td>
                </tr>
                <tr v-if="reportHideEnvironment && subtitleFormat !== ReportSubtitleType.type.BASIC">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1"
                  >
                    <strong>{{
                        (businessEvidenceFileRequiredFieldsObject.complementLabel || '').toUpperCase()
                      }}: </strong>

                    <span v-if="subtitleFormat !== ReportSubtitleType.type.NOT_ENVIRONMENT">
                      {{ textCheckUpperCase(checklistEnvironment.environment) }}
                    </span>

                    <span
                        v-if="subtitleFormat === ReportSubtitleType.type.FULL && objValid(photo.environmentComplement) && photo.environmentComplement !== ''">
                      - {{ textCheckUpperCase(photo.environmentComplement) }}
                    </span>

                    <span v-if="subtitleFormat === ReportSubtitleType.type.NOT_ENVIRONMENT">{{
                        textCheckUpperCase(photo.environmentComplement)
                      }}</span>

                  </td>
                </tr>

                <tr v-if="objValid(photo.typeEvidenceServiceAutomatically) && photo.typeEvidenceServiceAutomatically !== ''">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1"
                  >
                    <strong>{{ (businessEvidenceFileRequiredFieldsObject.serviceLabel || '').toUpperCase() }}:</strong>
                    {{ textCheckUpperCase(photo.typeEvidenceServiceAutomatically) }}
                  </td>
                </tr>

                <tr v-if="objValid(photo.typeEvidenceCategory) && photo.typeEvidenceCategory !== ''">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-line="1"
                  >
                    <strong>{{
                        (businessEvidenceFileRequiredFieldsObject.categoryLabel || '').toUpperCase()
                      }}: </strong>
                    {{ textCheckUpperCase(removeNumericPrefix(photo.typeEvidenceCategory)) }}

                    <strong v-if="objValid(photo.typeEvidenceStatus) && photo.typeEvidenceStatus !== ''">-
                      {{ (businessEvidenceFileRequiredFieldsObject.statusLabel || '').toUpperCase() }}: <span
                          :style="{'color': photo.typeEvidenceStatusTextColor}">{{
                          textCheckUpperCase(removeNumericPrefix(photo.typeEvidenceStatus))
                        }}</span></strong>

                  </td>
                </tr>


                <tr v-if="photo.subtitle && photo.subtitle.length > 0">
                  <td
                      style="padding:4px 4px;"
                      data-report-photo-observation="1"
                  >
                    <strong>OBSERVAÇÃO:</strong>
                    <span>
                      {{ photo.subtitle }}
                    </span>

                  </td>
                </tr>

                <tr>
                  <td
                      align="center"
                      valign="middle"
                      style="padding:18px 8px 22px 8px; height:330px;"
                      data-report-photo-image="1"
                      data-table-cell-padding-top="20px"
                      data-table-cell-padding-bottom="30px"
                  >
                    <img
                        :src="photo.fileWebMedium"
                        :width="evidenceLayoutType.imageWidth || 280"
                        :height="evidenceLayoutType.imageHeight || 360"
                        @load="onImgDone()"
                        @error="onImgDone(true, photo)"
                        style="display:block; object-fit:contain;"
                    >
                  </td>
                </tr>
              </table>

            </td>

            <!-- Completa coluna vazia -->
            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="padding:8px; width:50%;"
            >
              &nbsp;
            </td>
          </tr>
        </table>


        <table
            v-else-if="designType === ReportEvidenceDesignType.type.TECHNICAL_THICK_BORDER"
            align="center"
            border="1"
            cellspacing="0"
            cellpadding="0"
            :data-report-layout="ReportEvidenceDesignType.type.TECHNICAL_THICK_BORDER"
            style="border-collapse:collapse; width:100%; table-layout:fixed; font-family:Arial; font-size:9pt; border:2px solid #000;"
        >
          <tr
              v-for="(row, rIdx) in chunkArray(pagePhotos, evidenceLayoutType.qtyPhotosByRow)"
              :key="'row-tech-thick-' + checklistEnvironment.checklistEnvironmentId + '-' + pageIdx + '-' + rIdx"
          >
            <td
                v-for="photo in row"
                :key="photo.checklistEnvironmentEvidenceFileId"
                valign="top"
                style="width:100%; padding:0; border:2px solid #000;"
                data-report-photo-card="1"
                data-table-cell-border="1"
            >

              <table
                  width="100%"
                  border="1"
                  cellspacing="0"
                  cellpadding="0"
                  style="border-collapse:collapse; width:100%; table-layout:fixed;"
              >
                <colgroup>
                  <col style="width:10%;">
                  <col style="width:10%;">
                  <col style="width:80%;">
                </colgroup>

                <tr>
                  <td
                      colspan="3"
                      align="center"
                      valign="middle"
                      style="padding:28px 8px 28px 8px; height:330px; border:0; border-bottom:2px solid #000;"
                      data-report-photo-image="1"
                      data-table-cell-padding-top="28px"
                      data-table-cell-padding-bottom="28px"
                  >
                    <img
                        :src="photo.fileWebMedium"
                        :width="evidenceLayoutType.imageWidth || 640"
                        :height="evidenceLayoutType.imageHeight || 270"
                        @load="onImgDone()"
                        @error="onImgDone(true, photo)"
                        style="display:block; object-fit:contain; max-width:100%;"
                    >
                  </td>
                </tr>

                <tr>
                  <td
                      align="center"
                      valign="middle"
                      style="padding:7px 4px; border:0; border-right:2px solid #000; text-transform:uppercase"
                      data-report-photo-footer-label="1"
                  >
                    <strong>{{ textCheckUpperCase(sequenceOtherLabel) }}</strong>
                  </td>

                  <td
                      align="center"
                      valign="middle"
                      style="padding:7px 4px; border:0; border-right:2px solid #000;"
                      data-report-photo-footer-number="1"

                  >
                    <strong>{{ photo.position }}</strong>
                  </td>

                  <td
                      align="center"
                      valign="middle"
                      style="padding:7px 8px; border:0;"
                      data-report-photo-header="1"
                      data-report-photo-footer-description="1"
                  >
                    <strong>{{ textCheckUpperCase(photo.subtitle) }}</strong>
                  </td>
                </tr>
              </table>

            </td>

            <td
                v-if="row.length === 1 && evidenceLayoutType.qtyPhotosByRow > 1"
                align="center"
                valign="top"
                style="padding:8px; width:50%;"
            >
              &nbsp;
            </td>
          </tr>
        </table>




      </div>


    </div>

  </ReportViewSpecific>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import ui from "@/assets/scripts/ui";
import ReportViewSpecific from "@/views/modules/ReportViewSpecific.vue";
import http from "@/services/config/http-common";
import ReportEvidenceLayoutType from "@/model/types/modules/checklist/ReportEvidenceLayoutType";
import ReportSubtitleType from "@/model/types/modules/checklist/ReportSubtitleType";
import ChecklistService from "@/services/modules/checklist/Checklist.service";
import EnterpriseService from "@/services/modules/place/Enterprise.service";
import checklistService from "@/services/modules/checklist/Checklist.service";
import BusinessEvidenceFileEntity from "@/model/entities/modules/checklist/BusinessEvidenceFileEntity";
import ReportEvidenceDesignType from "@/model/types/modules/checklist/ReportEvidenceDesignType";
import ReportEnvironmentSortType from "@/model/types/modules/checklist/ReportEnvironmentSortType";

export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  components: {ReportViewSpecific},
  name: 'ReportPhotoEnterpriseEvidenceView',
  data() {
    return {
      ui,
      ReportEvidenceLayoutType,
      ReportSubtitleType,
      ReportEvidenceDesignType,
      busy: true,
      checklistResume: {},
      enterprise: {},
      checklistEnvironmentList: [],
      photosList: [],
      checklistId: 0,
      imagesTotal: 0,
      imagesLoaded: 0,
      imagesLoading: true,
      titleReport: "",
      subtitleSequenceStart: 1,
      subtitleFormat: 0,
      reportLayout: 0,
      reportHideEnvironment: false,
      sequenceOtherLabel: "Foto",
      subtitleUpperCase: false,
      designType: ReportEvidenceDesignType.type.DEFAULT,
      businessEvidenceFileRequiredFields: "",
      businessEvidenceFileLabelOrderFields: "",
      evidenceLayoutType: ReportEvidenceLayoutType.list[0],
      businessEvidenceFileRequiredFieldsObject: new BusinessEvidenceFileEntity(),
      environmentSort: ReportEnvironmentSortType.type.DEFAULT,
    }
  },
  methods: {

    async mountedPrepare() {

      /*---*/
      const checklistId = parseInt(this.$route.query.checklistId, 10)
      this.checklistId = Number.isInteger(checklistId) && checklistId > 0 ? checklistId : 0

      if (this.checklistId === 0) {
        ui.msgError(this, 'ChecklistId is required')
      }
      /*---*/

      /*---*/
      if (this.objValid(this.$route.query.titleReport)) {
        this.titleReport = this.$route.query.titleReport
      } else {
        this.titleReport = "RELATÓRIO FOTOGRÁFICO"
      }

      if (this.objValid(this.$route.query.sequenceOtherLabel)) {
        this.sequenceOtherLabel = this.$route.query.sequenceOtherLabel
      } else {
        this.sequenceOtherLabel = "Foto"
      }
      /*---*/

      /*---*/
      if (this.objValid(this.$route.query.businessEvidenceFileRequiredFields)) {
        this.businessEvidenceFileRequiredFields = this.$route.query.businessEvidenceFileRequiredFields
      }

      if (this.objValid(this.$route.query.businessEvidenceFileLabelOrderFields)) {
        this.businessEvidenceFileLabelOrderFields = this.$route.query.businessEvidenceFileLabelOrderFields
      }

      this.businessEvidenceFileRequiredFieldsObject = checklistService.onBusinessEvidenceFileRequiredFieldsFromString(this.businessEvidenceFileRequiredFields, this.businessEvidenceFileLabelOrderFields)
      /*---*/


      /*---*/
      const subtitleSequenceStart = parseInt(this.$route.query.subtitleSequenceStart, 10)
      this.subtitleSequenceStart = Number.isInteger(subtitleSequenceStart) && subtitleSequenceStart > 0 ? subtitleSequenceStart : 0

      if (this.subtitleSequenceStart === 0) {
        this.subtitleSequenceStart = 1
      }
      /*---*/

      /*---*/
      const subtitleFormat = parseInt(this.$route.query.subtitleFormat, 10)
      this.subtitleFormat = Number.isInteger(subtitleFormat) && subtitleFormat > 0 ? subtitleFormat : 0

      if (this.subtitleFormat === 0) {
        this.subtitleFormat = ReportSubtitleType.type.BASIC
      }
      /*---*/

      /*---*/
      const reportLayout = parseInt(this.$route.query.reportLayout, 10)
      this.reportLayout = Number.isInteger(reportLayout) && reportLayout > 0 ? reportLayout : 0
      if (this.reportLayout === 0) {
        this.reportLayout = ReportEvidenceLayoutType.type.BASIC_2_PHOTOS
      }

      this.evidenceLayoutType = ReportEvidenceLayoutType.list.find(a => a.value === this.reportLayout)
      /*---*/


      /*---*/
      const reportHideEnvironment = this.$route.query.reportHideEnvironment
      this.reportHideEnvironment = reportHideEnvironment === 'true'
      /*---*/


      /*---*/
      const designType = parseInt(this.$route.query.designType, 10)
      this.designType = Number.isInteger(designType) && designType > 0 ? designType : 1
      /*---*/

      /*---*/
      const environmentSort = parseInt(this.$route.query.environmentSort, 10)
      this.environmentSort = Number.isInteger(environmentSort) && environmentSort > 0 ? environmentSort : 1
      /*---*/


      /*---*/
      const subtitleUpperCase = this.$route.query.subtitleUpperCase
      this.subtitleUpperCase = subtitleUpperCase === 'true'
      /*---*/

    },
    async mountedContinued() {
      await this.getData()
    },

    async getData() {

      this.busy = true;

      await ChecklistService.getResume("id", this.checklistId).then(async checklistResume => {
        this.checklistResume = checklistResume
      })

      await EnterpriseService.getById(this.checklistResume.enterpriseId).then(async enterprise => {
        this.enterprise = enterprise
      })

      await http.get("checklist/environment?checklistId=" + this.checklistId).then(async (response) => {

        this.checklistEnvironmentList = response.data

      }).catch(error => {
        this.busy = false
        ui.generalResponseError(this, error)
      });

      await http.get("/checklist/environment-evidence-file/getAllImagesByChecklistId/" + this.checklistId + "?environmentSort=" + this.environmentSort).then(async (response) => {

        this.photosList = response.data
        this.busy = false

        let index = 0

        for (let photo of this.photosList) {
          photo.position = this.subtitleSequenceStart + index
          index++
        }

      }).catch(error => {
        this.busy = false
        ui.generalResponseError(this, error)
      });

    },

    /*----------------------------------------*/

    /*chunkArray(list, size) {
      const out = [];
      for (let i = 0; i < list.length; i += size) {
        out.push(list.slice(i, i + size));
      }
      return out;
    },*/

    //Conversão 1 a um pouco, pois Word não aceita text-transform e a conversão por lá é mais complexa do que repetir essa função.
    textCheckUpperCase(text) {

      if (this.objValid(text) && text !== '' && this.subtitleUpperCase) {
        return text.toUpperCase()
      } else {
        return text
      }

    },

    subtitleTextComplete(checklistEnvironment, photo, strongSequenceLabel) {
      const sequenceText = this.textCheckUpperCase(
          `${this.sequenceOtherLabel} ${photo.position}`
      );

      const sequence = strongSequenceLabel
          ? `<strong>${sequenceText}</strong>`
          : `<span>${sequenceText}</span>`;

      const sequenceNotStrong = `<span>${sequenceText}</span>`

      const wrapText = (text) => {
        return text ? `<span> ${text}</span>` : '';
      };

      const category = this.objValid(photo.typeEvidenceCategory) && photo.typeEvidenceCategory !== ''
          ? `${this.textCheckUpperCase(this.removeNumericPrefix(photo.typeEvidenceCategory))}:`
          : '';

      const subtitle = this.textCheckUpperCase(photo.subtitle || '');

      if (this.subtitleFormat === ReportSubtitleType.type.BASIC) {
        return [
          sequence,
          subtitle ? wrapText(`- ${subtitle}`) : ''
        ].filter(Boolean).join('');
      }

      if (this.subtitleFormat === ReportSubtitleType.type.NOT_ENVIRONMENT) {
        const complement = photo.environmentComplement && photo.environmentComplement.length > 0
            ? this.textCheckUpperCase(photo.environmentComplement)
            : '';

        return [
          sequence,
          complement ? wrapText(`- ${complement}`) : '',
          category ? wrapText(category) : '',
          subtitle ? wrapText(`- ${subtitle}`) : ''
        ].filter(Boolean).join('');
      }

      if (this.subtitleFormat === ReportSubtitleType.type.FULL) {

        const status = (
            this.objValid(photo.typeEvidenceStatus) &&
            photo.typeEvidenceStatus !== ''
        )
            ? `
          <strong>
            ${(this.textCheckUpperCase(this.businessEvidenceFileRequiredFieldsObject.statusLabel) || '')}:
            <span style="color:${photo.typeEvidenceStatusTextColor || '#000'}">
              ${this.textCheckUpperCase(this.removeNumericPrefix(photo.typeEvidenceStatus))}
            </span>
          </strong><br />
        `
            : '';

        const environment = this.textCheckUpperCase(checklistEnvironment.environment || '');

        const complement = photo.environmentComplement && photo.environmentComplement.length > 0
            ? this.textCheckUpperCase(photo.environmentComplement)
            : '';

        return [
          status,
          status === '' ? sequence : sequenceNotStrong, //Caso houver status, já possui Strong, por tanto irá deixar sem strong forçado
          environment ? wrapText(`- ${environment}`) : '',
          complement ? wrapText(`- ${complement}`) : '',
          category ? wrapText(category) : '',
          subtitle ? wrapText(`- ${subtitle}`) : ''
        ].filter(Boolean).join('');
      }

      return [
        sequence,
        category ? wrapText(`- ${category}`) : '',
        subtitle ? wrapText(`- ${subtitle}`) : ''
      ].filter(Boolean).join('');
    },

    chunkArray(arr, size) {
      if (!arr || !arr.length) return [];

      const result = [];

      for (let i = 0; i < arr.length; i += size) {
        result.push(arr.slice(i, i + size));
      }

      return result;
    },

    getEnvironmentPhotoPages(checklistEnvironmentId) {
      const photos = this.photosList.filter(
          a => a.checklistEnvironmentId === checklistEnvironmentId
      );

      return this.chunkArray(photos, this.evidenceLayoutType.qtyPhotosByPage);
    },

    removeNumericPrefix(text) {
      if (!text) return text;

      return text.replace(/^\s*\d+\s*-\s*/, "").trim();
    },

    resetImagesLoader() {
      // quantidade total de imagens esperadas
      this.imagesTotal = (this.photosList || []).length
      this.imagesLoaded = 0

      // se nao tem imagem, nao precisa loading
      if (this.imagesTotal === 0) {
        this.imagesLoading = false
        return
      }

      this.imagesLoading = true

      // importante: se algumas imagens vierem do cache, o evento load pode disparar muito rapido
      this.$nextTick(() => {
        const container = this.$refs.contentReport || document.getElementById("content-report")
        const imgs = container ? container.querySelectorAll("img") : []

        // se por algum motivo ja estiverem completas (cache), conta como carregadas
        let already = 0
        imgs.forEach(img => {
          if (img.complete) already++
        })

        if (already > 0) {
          this.imagesLoaded = already
          if (this.imagesLoaded >= this.imagesTotal) {
            this.imagesLoading = false
          }
        }
      })
    },

    onImgDone(isError, photo) {
      this.imagesLoaded++

      // opcional: log de erro
      if (isError) console.warn("Falha ao carregar imagem", photo && photo.fileWebMedium)

      if (this.imagesLoaded >= this.imagesTotal) {
        this.imagesLoading = false
      }
    },


  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {
    progressPercent() {
      if (!this.imagesTotal) return 0;
      return Math.round((this.imagesLoaded / this.imagesTotal) * 100);
    }
  },
  watch: {
    // sempre que mudar a lista de fotos, reinicia o controle de loading
    photosList: {
      immediate: true,
      handler() {
        this.resetImagesLoader()
      }
    }
  },

}
</script>
